export const NUMBER_REGEX = /^\d*(?:[.,]?\d+)?$/;

export const isValidNumber = (nr: string) => NUMBER_REGEX.test(nr);
